import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"

export const ResourceTechnology = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <>
      <div className="container mx-auto pt-10 mt-10">
        <div>
          <p className="lg:text-5xl md:text-3xl text-[16px] text-black font-semibold text-center">
            Do you want guidance on picking a <br /> specific stack for a
            project?
          </p>
        </div>
        <div className="flex justify-center pt-10 mt-5">
          <StaticImage
            className="mx-3 lg:mx-0 w-[90%]"
            src="./technolgies.png"
            alt="resourceHero"
            placeholder="blurred"
            layout="fullWidth"
          />
        </div>
        <div className="pt-10">
          <div className="lg:p-2 p-1 lg:w-full w-full">
            <div
              className={` w-full py-5 px-5 rounded-2xl h-full ${theme == "glassy" ? "bg-[rgba(255,255,255,0.24)] shadow-xl" : theme === "light" ? "bg-real-time-options" : theme === "dark" ? "bg-real-time-options" : "bg-[rgba(255,255,255,0.24)] shadow-xl"}`}
            >
              <div className="flex justify-between lg:px-10 py-8">
                {/* first-row */}
                <div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">AMP</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">AngularJS</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">flutter</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Ruby on Rails</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">React Native</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Docker</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Laravel</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">MEAN & MERN</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">JAMstack</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Python</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Sanity CMS</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Contently</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">.NET</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Apache</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">AWS CloudFormation</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">AWS Comprehend</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">AWS EC2</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">AWS Elasticsearch</p>
                  </div>
                </div>
                {/* second-row */}
                <div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">AWS Lambda</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">AWS Sagemaker</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">AWS S3</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">C#</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Contently</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Drupal</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Laravel</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Dynamics</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">DynamoDB</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">EPiServer</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">HTML5</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Java</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">LESS/Sass</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Linux</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Magento</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">PHP</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Postgre</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Salesforce Integration</p>
                  </div>
                </div>
                {/* third-row */}
                <div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Shopify</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Sitecore</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">SQL/NoSQL</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Vue.js</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">WooCommerce</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Xamarin</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Typescript</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Apollo Graphql</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Firebase</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Express</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Kotlin</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Elixir</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">ES6 Features</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">JSX Components</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Tailwind CSS</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Bulma CSS</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Bootstrap 4</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Materialized CSS</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto pt-10 mt-10">
        <div>
          <p className="lg:text-5xl md:text-3xl text-[16px] text-black font-semibold text-center">
            Consulting Services For Startups And <br />
            Solutions In Shape Of Execution!
          </p>
        </div>
        <div className="pt-10">
          <div className="lg:p-2 p-1 lg:w-full w-full">
            <div
              className={` w-full py-5 px-5 rounded-2xl h-full ${theme == "glassy" ? "bg-[rgba(255,255,255,0.24)] shadow-xl" : theme === "light" ? "bg-real-time-options" : theme === "dark" ? "bg-real-time-options" : "bg-[rgba(255,255,255,0.24)] shadow-xl"}`}
            >
              <div className="flex justify-between lg:px-10 py-8">
                {/* first-row */}
                <div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Systems Architecture</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Microservices Architecture
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">User Interface Design</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Systems Design & Integration
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">User Experience Design</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Enterprise Development</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      E-Commerce Optimization
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Application Development
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Architecture & Engineering
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Application Maintenance
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Application Security</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Content Management System
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">CRM</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Analytics</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Modern Application Stacks
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Digital Transformation</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Product Design Sprint</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Enterprise Software Development
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Cloud-based Application
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Development</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Enterprise Mobile App Development
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Modern Application Stacks
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Custom Mobile Applications
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      ReactNative Mobile Development
                    </p>
                  </div>
                </div>
                {/* second-row */}
                <div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Documentation</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Information Architecture
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">IT Management</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Platform Migration</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Process Management</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Process Optimization</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">SaaS</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">System Integration</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">System Specification</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Technology Procurement</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Advanced Analytics & Reporting
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Amazon Web Services (AWS)
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Project Development</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Testing & Quality Assurance
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      API & Algorithm Development
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Business Intelligence</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Flutter Mobile Development
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Enterprise Mobile App Development
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Scoping Session</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Digital Transformation</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">EFintech</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Progressive Web Apps</p>
                  </div>
                </div>
                {/* third-row */}
                <div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Database Solutions</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Software Development & Support
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Cloud Migration</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Offshore/Onshore IT Management
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      High-Performance Computing
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Systems Audit & Analysis
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">AI Search Solutions</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Infrastructure-as-a-Service (IaaS)
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Network Infrastructure</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">On-Demand Services</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">DAMS/DRM</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">White Label Services</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Machine Learning (ML) Solutions
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Marketing Automation</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Transformation</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Technology Roadmapping</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Business Intelligence</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Cloud Technology</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Machine Learning</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">Data Annotation</p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">
                      Android App Development
                    </p>
                  </div>
                  <div className="flex gap-2 pt-2">
                    <p className="text-xs text-black relative bottom-1">.</p>
                    <p className="text-xs text-black">IOS App Development</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
